import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './loader/loader.component';
import { ShimmerLoaderComponent } from './shimmer-loader/shimmer-loader.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './loader/loading.interceptor';
import { WaterMeterDnDropdownComponent } from './water-meter-dn-dropdown/water-meter-dn-dropdown.component';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SelectComponent } from './select/select.component';
import { SearchNameFilterPipe } from './pipe/filter/searchName-filter.pipe';
import { HttpErrorInterceptor } from './httpError/httpError.interceptor';
import { EditableLabelComponent } from './editable-label/editable-label.component';
import { EditableNumberComponent } from './editable-number/editable-number.component';
import { EditableTextareaComponent } from './editable-textarea/editable-textarea.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button';
import { FromNowPipe } from './pipes/from-now.pipe';
import { DurationPipe } from './pipes/duration.pipe';
import { WaterConsumptionInUnit } from './pipes/WaterConsumptionInUnit';
import { PowerConsumptionInUnit } from './pipes/PowerConsumptionInUnit';

import { DateToStringPipe } from './pipes/dateToString.pipe';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { TriphaseCurrentTransformerDropdownComponent } from './triphase-current-transformer-dropdown/triphase-current-transformer-dropdown.component';
import { UnreachableBadgeComponent } from './unreachable-badge/unreachable-badge.component';
import { NoConsumptionBadgeComponent } from './no-consumption-badge/no-consumption-badge.component';
import { SectionHeaderComponent } from './section-header/section-header.component';
import { PageComponent } from './page/page.component';
import { SignalQualityBadgeComponent } from './signal-quality-badge/signal-quality-badge.component';
import { MeasurementDisplayComponent } from './measurement-display/measurement-display.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { SiteSelectorComponent } from './site-selector/site-selector.component';
import { DeviceDocumentationButtonComponent } from './device-documentation-button/device-documentation-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { TariffPeriodsHintComponent } from './tariff-periods-hint/tariff-periods-hint.component';

@NgModule({
  declarations: [
    LoaderComponent,
    ShimmerLoaderComponent,
    SelectComponent,
    SearchNameFilterPipe,
    EditableLabelComponent,
    EditableNumberComponent,
    EditableTextareaComponent,
    FromNowPipe,
    DurationPipe,
    PowerConsumptionInUnit,
    WaterConsumptionInUnit,
    DateToStringPipe,
    CurrencyFormatPipe,
    WaterMeterDnDropdownComponent,
    TriphaseCurrentTransformerDropdownComponent,
    UnreachableBadgeComponent,
    NoConsumptionBadgeComponent,
    SectionHeaderComponent,
    PageComponent,
    SignalQualityBadgeComponent,
    MeasurementDisplayComponent,
    SearchInputComponent,
    SiteSelectorComponent,
    DeviceDocumentationButtonComponent,
    TariffPeriodsHintComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    FontAwesomeModule,
    InputTextModule,
    InputTextareaModule,
    InputNumberModule,
    ButtonModule,
    DropdownModule,
    TooltipModule,
    TranslateModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ShimmerLoaderComponent,
    SelectComponent,
    SearchNameFilterPipe,
    EditableLabelComponent,
    EditableNumberComponent,
    EditableTextareaComponent,
    FromNowPipe,
    DurationPipe,
    PowerConsumptionInUnit,
    WaterConsumptionInUnit,
    DateToStringPipe,
    CurrencyFormatPipe,
    WaterMeterDnDropdownComponent,
    TriphaseCurrentTransformerDropdownComponent,
    UnreachableBadgeComponent,
    NoConsumptionBadgeComponent,
    SectionHeaderComponent,
    PageComponent,
    SignalQualityBadgeComponent,
    MeasurementDisplayComponent,
    SearchInputComponent,
    SiteSelectorComponent,
    DeviceDocumentationButtonComponent,
    TariffPeriodsHintComponent,
    TranslateModule,
  ],
  providers: [
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
  ],
})
export class SharedModule {
  public static forRoot(): ModuleWithProviders<SharedModule> {
    return { ngModule: SharedModule };
  }
}
